import type Store from '@ember-data/store';
import type { Ota } from 'frontend-utils/models';
import { PREFERRED_CHANNEL_STATUSES } from 'lumen/utils/constants/pricing-assistant-constants';

// Helper function to get the name of the preferred channel that is in progress
// first we get the key of the channel that is in progress and use that to retrieve the full name from an ota record in the Ember store.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function preferredChannelInProgressName(
  recommendationsChannels: Record<string, string>,
  store: Store,
) {
  const recommendationsChannelsInProgress = Object.entries(
    recommendationsChannels,
  ).filter(([, status]) => status === PREFERRED_CHANNEL_STATUSES.IN_PROGRESS);

  if (recommendationsChannelsInProgress.length >= 1) {
    const channelInProgress = recommendationsChannelsInProgress[0]?.[0];

    let ota = null;
    if (channelInProgress) {
      ota = store.peekRecord<Ota>('ota', channelInProgress);
    }

    if (ota) {
      return ota.name;
    }
  }

  return '';
}
